
<modal #modal
  id="incidentModal"
  [(errorMessage)]="_errorMessage"
  *ngIf="_appService && _appService.CoreCommonLiterals !== undefined && modalVisible"
  modalClass="modal-xxl"
  (onClose)="onCloseModal()"
  [submitButtonText]="_appService.CoreCommonLiterals.ButtonSave"
  [enabledDropdownsubmitButton]="parameters?.IncidentElementTypeID === incidentManagementTypes.Incidents ? true : false"
  [menuButtonList]="menuButtonList"
  [submitButtonDisabled]="disabledForm"
  (onSubmit)="onConfirmSave(parameters?.IncidentElementTypeID)"
  (onAction)="onSave(parameters?.IncidentElementTypeID, $event)"
  [cancelButtonText]="parameters?.IncidentElementTypeID === incidentManagementTypes.Incidents ? _appService.CoreCommonLiterals.ButtonCancel : ''"
  (onCancel)="parameters?.IncidentElementTypeID === incidentManagementTypes.Incidents ? _incidentForm?.cancelForm() : null"
  [closeButtonText]="parameters?.IncidentElementTypeID !== incidentManagementTypes.Incidents ? _appService?.CoreCommonLiterals?.ButtonCancel : ''"
>
  <modal-header 
  *ngIf="parameters?.IncidentElementTypeID !== incidentManagementTypes.AssociateIncident && 
  parameters?.IncidentElementTypeID !== incidentManagementTypes.DisassociateIncident && 
  parameters?.IncidentElementTypeID !== incidentManagementTypes.IncidentFile">
  {{((parameters?.Editing) ? _appService?.CoreCommonLiterals.Edit : _appService?.CoreCommonLiterals.Add)}}
    -
    <span *ngIf="parameters?.IncidentElementTypeID === incidentManagementTypes.WorkShifts">Turno</span> 
    <span *ngIf="parameters?.IncidentElementTypeID === incidentManagementTypes.Communications">Comunicado</span>
    <span *ngIf="parameters?.IncidentElementTypeID === incidentManagementTypes.Incidents">Evento</span>
  </modal-header>
  <modal-header *ngIf="parameters?.IncidentElementTypeID === incidentManagementTypes.AssociateIncident">Asociar Evento</modal-header>
  <modal-header *ngIf="parameters?.IncidentElementTypeID === incidentManagementTypes.DisassociateIncident">Desasociar Evento</modal-header>
  <modal-header *ngIf="parameters?.IncidentElementTypeID === incidentManagementTypes.IncidentFile">Ficha de emergencia del evento: {{parameters.IncidentID}}</modal-header>


  <modal-content>
    <div *ngIf="parameters?.IncidentElementTypeID === incidentManagementTypes.Incidents"> 
      <app-incident-form 
      #incidentForm
      [incidentID]="parameters.IncidentID"
      [communicationIDs]="parameters.CommunicationIDs"
      [displayOnModal]="true"
      (incidentClosed)="setMenuList($event)"
      (onCloseForm)="onCloseForm()"
      ></app-incident-form>
     </div>
     <div *ngIf="parameters?.IncidentElementTypeID === incidentManagementTypes.Communications">
      <app-communication 
      #communicationForm 
      [displayOnModal]="true"
      [communicationID]="parameters.CommunicationIDs[0]"
      (click)="_errorMessage = ''"
      (onCloseForm)="onCloseForm()"
      (onError)="_errorMessage = $event;"
      ></app-communication>
    </div>
    <div *ngIf="parameters?.IncidentElementTypeID === incidentManagementTypes.IncidentFile">
      <app-incident-file
      #incidentFileForm
      [incidentID]="parameters.IncidentID"
      (onCloseForm)="onCloseForm()"
      ></app-incident-file>
    </div>
    <div *ngIf="parameters?.IncidentElementTypeID === incidentManagementTypes.AssociateIncident">
      <app-associate-incidents 
      #associateIncident 
      [communicationIDs]="parameters.CommunicationIDs"
      (disableForm)="onDisabledForm($event);" 
      (onCloseForm)="onCloseForm()"
      ></app-associate-incidents>
    </div>
    <div *ngIf=" parameters?.IncidentElementTypeID === incidentManagementTypes.DisassociateIncident">
      <div class="text-center my-2 d-flex align-items-center justify-content-center" style="min-height: 100vh;">
        <i class="fa-solid fa-screwdriver-wrench fa-4x text-primary mr-2"></i>
        <p class="h5 text-muted my-2">En construcción</p>
      </div>
    </div>
  </modal-content>
</modal>